if (!customElements.get('product-tabs')) {
  customElements.define(
    'product-tabs',
    class ProductTabs extends HTMLElement {
      connectedCallback() {
        this.list = this.querySelector('[data-tabs-list]');
        this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
        this.prev = this.querySelector('[data-tabs-prev]');
        this.next = this.querySelector('[data-tabs-next]');

        this.tabs.forEach((tab, index) => {
          tab.addEventListener('click', () => this.select(index));
          tab.addEventListener('keydown', (event) => this.onKeydown(event, index));
        });

        // Phone carousel arrows: move by most of a visible width, and only show when the row overflows.
        this.prev.addEventListener('click', () => this.scrollList(-1));
        this.next.addEventListener('click', () => this.scrollList(1));
        this.list.addEventListener('scroll', () => this.updateArrows(), { passive: true });
        this.resizeObserver = new ResizeObserver(() => this.updateArrows());
        this.resizeObserver.observe(this.list);
        this.updateArrows();
      }

      disconnectedCallback() {
        this.resizeObserver?.disconnect();
      }

      select(index, focus = false) {
        this.tabs.forEach((tab, i) => {
          const selected = i === index;
          const panel = document.getElementById(tab.getAttribute('aria-controls'));
          tab.setAttribute('aria-selected', selected ? 'true' : 'false');
          tab.tabIndex = selected ? 0 : -1;
          if (panel) panel.hidden = !selected;
        });
        const active = this.tabs[index];
        if (focus) active.focus();
        active.scrollIntoView({
          behavior: this.reducedMotion() ? 'auto' : 'smooth',
          inline: 'nearest',
          block: 'nearest',
        });
      }

      onKeydown(event, index) {
        const last = this.tabs.length - 1;
        const target = {
          ArrowRight: index === last ? 0 : index + 1,
          ArrowLeft: index === 0 ? last : index - 1,
          Home: 0,
          End: last,
        }[event.key];
        if (target === undefined) return;
        event.preventDefault();
        this.select(target, true);
      }

      scrollList(direction) {
        this.list.scrollBy({
          left: direction * this.list.clientWidth * 0.6,
          behavior: this.reducedMotion() ? 'auto' : 'smooth',
        });
      }

      updateArrows() {
        const overflow = this.list.scrollWidth > this.list.clientWidth + 1;
        this.prev.hidden = !overflow;
        this.next.hidden = !overflow;
        if (!overflow) return;
        this.prev.disabled = this.list.scrollLeft <= 1;
        this.next.disabled = this.list.scrollLeft + this.list.clientWidth >= this.list.scrollWidth - 1;
      }

      reducedMotion() {
        return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      }
    }
  );
}
